import ColumnHeading from '@/components/column-heading';
import FlowCard from '@/components/flow-card';

export const nodeTypes = {
	columnHeading: ColumnHeading,
	flowCard: FlowCard
};
